/**
 * Micheals Infrastructure Advisory - UNIFIED SERVICE LAYER
 * ROLE: Consolidated Access to Intelligence & Provisioning Hubs
 */
import { apiClient, ROUTES } from '../../utils/apiClient';

// Helper to wrap payload with Metadata
const withMetadata = (data) => ({
  ...data,
  firm_model: "Principal_Oversight_2026",
  timestamp: new Date().toISOString()
});

/**
 * TELEMETRY & TRACKING
 */
export const trackEvent = async (eventData) => {
  try {
    await apiClient(ROUTES.TRACK_VISITOR, {
      method: 'POST',
      body: JSON.stringify(withMetadata({
        ...eventData,
        interaction_type: "PROSPECT_STAKE_HOLDER_ENGAGEMENT"
      })),
    });
    console.log(`📡 [TELEMETRY_DISPATCH]: Event sent: ${eventData.type || 'Standard Track'}`);
  } catch (error) {
    if (error.message.includes('404')) {
      console.warn("Telemetry endpoint unreachable. Skipping.");
      return; 
    }
    console.error("Telemetry failed:", error);
  }
};

/**
 * FINANCIAL & PROVISIONING
 */
export const initializeConsultationPayment = async (briefData) => {
  return await apiClient(ROUTES.CREATE_PAYMENT, {
    method: 'POST',
    body: JSON.stringify(withMetadata(briefData))
  });
};

export const submitIntakeBrief = async (briefData) => {
  return await apiClient(ROUTES.GENERATE_BRIEF, {
    method: 'POST',
    body: JSON.stringify(withMetadata({
      ...briefData,
      intent: "FORMAL_DESIGN_AUDIT_REQUEST"
    }))
  });
};

export const getCapitalEstimate = async (criteria) => {
  return await apiClient(ROUTES.GET_MARKET_QUOTE, {
    method: 'POST',
    body: JSON.stringify(withMetadata({
      ...criteria,
      request_type: "INFRASTRUCTURE_CAPITAL_ALLOCATION_GUIDE"
    }))
  });
};

// Strategic Aliases for legacy support
export const trackLead = trackEvent;
export const submitBooking = submitIntakeBrief;
export const getMarketQuote = getCapitalEstimate;